import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2 flex-wrap"
}
const _hoisted_2 = { class: "flex items-center -space-x-1" }
const _hoisted_3 = ["onClick", "title"]
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "text-sm text-primary-500" }
const _hoisted_6 = {
  key: 0,
  class: "hidden sm:inline"
}
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-primary-400"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-primary-400"
}

import { computed, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  reactions: {
    type: Array as PropType<ReactionSummary[]>,
    default: () => [],
  },
  maxDisplay: {
    type: Number,
    default: 6,
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  showSocialProof: {
    type: Boolean,
    default: false,
  },
  showEmptyState: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props) {

const props = __props





const emojiMap: Record<ReactionType, string> = {
  like: "👍",
  love: "❤️",
  laugh: "😄",
  thinking: "🤔",
  clap: "👏",
  "100": "💯",
};

const getEmoji = (type: ReactionType): string => {
  return emojiMap[type] || "👍";
};

const sortedReactions = computed(() => {
  return [...props.reactions].sort((a, b) => b.count - a.count);
});

const totalCount = computed(() => {
  return props.reactions.reduce((sum, r) => sum + r.count, 0);
});

const socialProofText = computed(() => {
  if (totalCount.value === 0) return "";

  const userReacted = props.reactions.some((r) => r.user_reacted);

  if (userReacted && totalCount.value === 1) {
    return "You reacted";
  } else if (userReacted && totalCount.value === 2) {
    return "You and 1 other";
  } else if (userReacted) {
    return `You and ${totalCount.value - 1} others`;
  } else if (totalCount.value === 1) {
    return "1 neighbor reacted";
  } else {
    return `${totalCount.value} neighbors reacted`;
  }
});

const getTooltip = (reaction: ReactionSummary): string => {
  const emoji = getEmoji(reaction.reaction_type);
  if (reaction.users && reaction.users.length > 0) {
    const names = reaction.users
      .slice(0, 3)
      .map((u) => u.name)
      .join(", ");
    const remaining = reaction.users.length - 3;
    if (remaining > 0) {
      return `${emoji} ${names} and ${remaining} more`;
    }
    return `${emoji} ${names}`;
  }
  return `${emoji} ${reaction.count}`;
};

return (_ctx: any,_cache: any) => {
  return (__props.reactions.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedReactions).slice(0, __props.maxDisplay), (reaction) => {
            return (_openBlock(), _createElementBlock("button", {
              key: reaction.reaction_type,
              onClick: ($event: any) => (_ctx.$emit('click', reaction.reaction_type)),
              class: _normalizeClass(["inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-50 border-2 border-white hover:scale-110 transition-transform cursor-pointer", { 'ring-2 ring-accent-300': reaction.user_reacted }]),
              title: getTooltip(reaction)
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(getEmoji(reaction.reaction_type)), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(_unref(totalCount)) + " ", 1),
          (__props.showLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(totalCount) === 1 ? "reaction" : "reactions"), 1))
            : _createCommentVNode("", true)
        ]),
        (__props.showSocialProof && _unref(socialProofText))
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(socialProofText)), 1))
          : _createCommentVNode("", true)
      ]))
    : (__props.showEmptyState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Be the first to react "))
      : _createCommentVNode("", true)
}
}

})